<div class="custom-tooltip" [ngClass]="{'no-active':!isTooltipDisplay}">
    <p>
        <span class="helpText helpText-rowHover">{{ tooltipText | translate }}</span>
    </p>
</div>